// 引入api
import { fun_PostAction } from "@/api";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      id: null, // 主键
      // 中标公示信息
      form: {
        id: null, // 主键
        regulators: null, // 区管代码
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        buildCorp: null, // 建设单位
        corpLegal: null, // 法定代表
        linkMan: null, // 联系人
        linkTel: null, // 联系人电话
        noteNumber: null, // 立项批准文号
        projectSite: null, // 工程地点
        fundsCharacter: null, // 资金性质
        fundsSources: null, // 资金来源及落实情况
        economicType: null, // 公司经济类型
        recordUnitName: null, // 项目核准或备案单位名称
        approvalName: null, // 批文名称
        buildingLandObtained: null, // 建设用地取得方式
        constructionArea: null, // 房屋建筑工程建筑面积
        structuralHierarchy: null, // 结构层次
        municipalProjectScale: null, // 市政工程规模
        otherProjectScale: null, // 其它工程规模
        constructionUnit: null, // 施工单位
        qualificationCategories: null, // 企业资质类别及等级
        projectManager: null, // 项目经理
        qualificationCategoryLevel: null, // 执业资格类别等级及编号
        managerCertificateNumber: null, // 项目经理安全生产考核合格证书编号
        managementCertificateNumber: null, // 专职安全生产管理人员安全生产考核合格证书编号
        planTimeLimit: null, // 计划工期
        projectCost: null, // 工程造价
        contractScope: null, // 发包范围
        state: null, // 状态
        lockNo: null, // CA锁编号
        digitalSignature: null, // 数字签名
        timeStamp: null, // 时间戳
        inputPerson: null, // 录入人员
        inputMode: null, // 录入方式
        insertDate: null, // 插入日期
        updateDate: null, // 更新日期
        situation: null, // 资金来源落实情况
        remarks: null, // 备注
        constructionUnitName: null, // 施工单位名称
        managementCertificateName: null, // 专职安全生产管理人员
        contractorLockNo: null, // 施工方CA锁编号
        contractorDigitalSignature: null, // 施工方数字签名
        contractorTimeStamp: null, // 施工方时间戳
        sealDate: null, // 盖章日期
        tenderClassNum: null, // 招标类别
        tenderContentNum: null, // 招标内容
        processState: null, // 流程状态
        projectManagerId: null, // 项目经理解锁变更记录表主键
        updateFlag: null, // 修改标志（修改发包人或施工方）
        recordState: null, // 备案状态(0正常，1解除合同，2申请解除中)
        isAuditOk: null, // 审核通过的标志
        actualAuditTime: null, // 实际审核推送时间
        auditFinalTime: null, // 审核最终时间
        projectLeaderNumber: null, // 审核最终时间
        regulatorsName: null, // 区管代码名称
        projectManagerName: null, // 项目经理名称
        publishState: null, // 公示状态
        expectAuditTime: null, // 预计审核推送时间
        totalInvestment: null, // 批准投资总额（万元）
        projectManagerIdCard: null, // 项目经理身份证号码
        projectLeaderName: null, // 公示项目负责人名称
        isUnion: null, // 是否允许联合体
        econUnit: null, // 勘察单位
        econUnitName: null, // 勘察单位名称
        econProjectManager: null, // 勘察项目负责人
        econProjectManagerName: null, // 勘察项目经理名称
        econProjectManagerIdCard: null, // 勘察项目经理身份证号码
        designUnit: null, // 设计单位
        designUnitName: null, // 设计单位名称
        designProjectManager: null, // 设计项目负责人
        designProjectManagerName: null, // 设计项目经理名称
        designProjectManagerIdCard: null, // 设计项目经理身份证号码
        superUnit: null, // 监理单位
        superUnitName: null, // 监理单位名称
        superProjectManager: null, // 监理项目负责人
        superProjectManagerName: null, // 监理项目经理名称
        superProjectManagerIdCard: null, // 监理项目经理身份证号码
        constructionState: null, // 施工单位确认状态
        constructionSealDate: null, // 施工单位盖章日期
        econState: null, // 勘察单位确认状态
        econSealDate: null, // 勘察单位盖章日期
        designState: null, // 设计单位确认状态
        designSealDate: null, // 设计单位盖章日期
        superState: null, // 监理单位确认状态
        superSealDate: null, // 监理单位盖章日期
        econProjectCost: null, // 勘察工程造价
        designProjectCost: null, // 设计工程造价
        superProjectCost: null, // 监理工程造价
      },
      tableA: true, // 收起 展开 招标/资格预审公告信息
      // 招标/资格预审公告信息
      tableAList: [
        {
          name: "报建编号",
          value: "constructionNo",
          class: "all"
        },
        {
          name: "工程名称",
          value: "prjName",
          class: "all"
        },
        {
          name: "备案部门",
          value: "regulatorsName",
          class: "all"
        },
        {
          name: "备案项目类别",
          value: "tenderClassName"
        },
        {
          name: "备案项目内容",
          value: "tenderContentName"
        },
        {
          name: "建设单位",
          value: "buildCorp",
          class: "all"
        },
        {
          name: "建设单位法人代表",
          value: "corpLegal",
          class: "all"
        },
        {
          name: "建设单位法人授权委托人及授权委托人电话",
          value: "linkMan",
          class: "all"
        },
        {
          name: "立项批准文号",
          value: "noteNumber"
        },
        {
          name: "工程地点",
          value: "projectSite"
        },
        {
          name: "资金性质",
          value: "fundsCharacter"
        },
        {
          name: "资金来源及落实情况",
          value: "fundsSources"
        },
        {
          name: "房屋建筑工程建筑面积（㎡）",
          value: "constructionArea"
        },
        {
          name: "结构层次",
          value: "structuralHierarchy"
        },
        {
          name: "市政工程规模",
          value: "municipalProjectScale",
          class: "all"
        },
        {
          name: "其它工程规模",
          value: "otherProjectScale",
          class: "all"
        },
        {
          name: "施工单位",
          value: "constructionUnitName"
        },
        {
          name: "企业资质类别及等级",
          value: "qualificationCategories"
        },
        {
          name: "项目负责人",
          value: "projectLeaderName"
        },
        {
          name: "项目负责人安全生产考核合格证书编号",
          value: "managerCertificateNumber"
        },
        {
          name: "专职安全生产管理人员姓名",
          value: "managementCertificateName"
        },
        {
          name: "专职安全生产管理人员安全生产考核合格证书编号",
          value: "managementCertificateNumber"
        },
        {
          name: "计划工期（日历天）",
          value: "planTimeLimit"
        },
        {
          name: "工程造价（万元）",
          value: "projectCost"
        },
        {
          name: "发包范围",
          value: "contractScope",
          class: "all"
        },
        {
          name: "勘察单位",
          value: "econUnitName",
          class: "all"
        },
        {
          name: "勘察项目负责人",
          value: "econProjectManagerName"
        },
        {
          name: "勘察工程造价（万元）",
          value: "econProjectCost"
        },
        {
          name: "设计单位",
          value: "designUnitName",
          class: "all"
        },
        {
          name: "设计项目负责人",
          value: "designProjectManagerName"
        },
        {
          name: "设计工程造价（万元）",
          value: "designProjectCost"
        },
        {
          name: "监理单位",
          value: "superUnitName",
          class: "all"
        },
        {
          name: "监理项目负责人",
          value: "superProjectManagerName"
        },
        {
          name: "监理工程造价（万元）",
          value: "superProjectCost"
        },
        {
          name: "发布时间",
          value: "auditFinalTime",
          class: "all"
        },
      ],
      /***************************************联合体单位*******************************************/
      unionLoading: false, // 列表loading状态
      // 联合体单位表单
      unionForm:{
        unionCorpId: null, // 联合体单位编号
        unionCorpName: null, // 联合体单位名称
        unionUnitType: null, // 联合体单位类型
        unionUnitTypeName: null, // 联合体单位类型名称
      },
      // 表格基础数据
      unionTableColumns: [
        {
          label: "联合体单位名称",
          prop: "unionCorpName"
        },
        {
          label: "联合体单位类型",
          prop: "unionUnitTypeName"
        },
        {
          label: "是否同意",
          slotName: "isAgree"
        },
        {
          label: "确认日期",
          prop: "sealDate"
        },
      ],
      // 表格数据
      unionTableData: [],
      /************************************工程施工单位项目管理机构配备情况**********************************/
      // 列表loading
      loading: false,
      // 列表配置
      tableColumns: [
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "职务",
          prop: "duty"
        },
        {
          label: "职称",
          prop: "positionalTitles"
        },
        {
          label: "证书名称",
          prop: "certificateName"
        },
        {
          label: "级别",
          prop: "level"
        },
        {
          label: "证号",
          prop: "number"
        },
        {
          label: "专业",
          prop: "professional"
        },
        {
          label: "备注",
          prop: "remarks"
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      /************************************项目负责人变更情况**********************************/
      // 列表loading
      managerLoading: false,
      // 列表配置
      managerTableColumns: [
        {
          label: "原项目负责人名称",
          prop: "regBasicInfoName",
        },
        {
          label: "变更后项目负责人名称",
          prop: "basicInfoChangeName"
        },
        {
          label: "变更时间",
          prop: "auditDate"
        },
      ],
      // 表格数据
      managerTableData: [],
      // 分页
      managerReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      managerTotal: 0, // 总条数
    };
  },
  // 注册组件
  components: {
  },
  mounted() {
    // 主键
    this.id = this.$route.query.id,
    // 获取公告详情
    this.fun_GetDetail();
    // 直接发包联合单位信息
    this.fun_ContractRecordUnionList();
    // 工程施工单位项目管理机构配备情况
    this.fun_GetOrganizationAllocationinfoList();
    // 项目负责人变更
    this.fun_GetProjectManagerRecordList();
  },
  // 自定义事件
  methods: {
    /**
     * 获取公告信息
     */
    fun_GetDetail() {
       // 请求
       fun_PostAction("/cmsHomePage/contractRecordDirectlyDetail", {
        id: this.id,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 直接发包详情
          this.form = data;
          // 建设单位法人授权委托人
          this.form.linkMan = this.form.linkMan + '、' + this.form.linkTel;
          // 资金来源及落实情况
          this.form.fundsSources = this.form.fundsSources + '、' + this.form.situation;
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 联合体单位集合
     */
    fun_ContractRecordUnionList(){
      // 主键不为空
      if(this.id){
        // 打开loading
        this.unionLoading = true;
        // 发起请求
        fun_PostAction("/cmsHomePage/contractRecordUnionList", {
          recordDirectlyId: this.id,
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 操作成功
          if (result) {
            // 联合体列表数据
            this.unionTableData = data;
          }
          // 关闭加载
          this.unionLoading = false;
        });
      }
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetOrganizationAllocationinfoList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/cmsHomePage/organizationAllocationinfoList", {
        ...this.reqPageData,
        contractRecordDirectlyId: this.id,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetOrganizationAllocationinfoList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetOrganizationAllocationinfoList();
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetProjectManagerRecordList() {
      // 打开loading
      this.managerLoading = true;
      // 发起请求
      fun_PostAction("/cmsHomePage/projectManagerRecordPageList", {
        ...this.managerReqPageData,
        contractRecordDirectlyId: this.id,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.managerTableData = records;
          // 获取分页总条数
          this.managerTotal = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.managerLoading = false;
      })
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_ManagerLimitChange(e) {
      // 获取每页显示条数
      this.managerReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetProjectManagerRecordList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_ManagerPageChange(e) {
      // 获取当前页码
      this.managerReqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetProjectManagerRecordList();
    },
    /**
     * 返回
     */
    fun_Back(){
      // 返回
      this.$router.back();
    },
  }
};
